import { createMuiTheme } from '@material-ui/core';
import { COLORS } from './colors';

export default createMuiTheme({
  palette: {
    primary: {
      main: COLORS.primary.main,
      dark: COLORS.primary.hover,
    },
    secondary: {
      main: COLORS.secondary.main,
    },
    text: {
      primary: COLORS.grayScale[5],
      secondary: COLORS.secondary.main,
    },
  },
  typography: {
    fontFamily: 'Raleway',
  },
  overrides: {
    MuiButton: {
      root: {
        height: '3.125rem',
        color: COLORS.grayScale[1],
      },
      label: {
        fontSize: '1rem',
        fontWeight: 'bold',
        lineHeight: '1.1875rem',
      },
      contained: {
        padding: '0.875rem 1.875rem',
        '&$disabled': {
          color: COLORS.grayScale[1],
          backgroundColor: COLORS.primary.main,
          opacity: 0.5,
        },
      },
      outlined: {
        color: COLORS.primary.main,
        padding: '0.875rem 1.875rem',
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: COLORS.grayScale[1],
      },
    },
  },
});
